import { VisitTemplate } from '@dreryk/egabinet-visit-frontend-api';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

type VisitTemplatesUseTemplateModalConfirmButtonProps = {
   readonly onClick: (template: VisitTemplate) => void;
};

export const VisitTemplatesUseTemplateModalConfirmButton = (
   props: VisitTemplatesUseTemplateModalConfirmButtonProps
): JSX.Element => {
   return <FormsTemplates.UseTemplateModalConfirmButton<VisitTemplate> onClick={props.onClick} />;
};
